import React from "react";
import { useTranslation } from "react-i18next";
import LoginLayout from "../../components/LoginLayout";

const EmptyInvitation = () => {
	const { t } = useTranslation();

	return (
		<LoginLayout>
			<p>{t("modules.security.field.empty_invitation.title")}</p>
			<a href={"/"} className={"btn btn-primary"}>
				{t("modules.security.action.back.title")}
			</a>
		</LoginLayout>
	);
};

export default EmptyInvitation;
